/**
 * Function to return correct text based on Invest and Wealth relationships.
 *
 * @param isInvestUser
 * @param isWealthClient
 *
 * @returns {string}
 */
export function getInvestWealthText(isInvestUser, isWealthClient, isPersonalAdviceEnabled, isWealthDown, isInvestDown) {
    const showWealth = isWealthClient && !isWealthDown;
    const showInvest = isInvestUser && !isInvestDown;
    const wealthText = isPersonalAdviceEnabled
        ? 'Personal Advice'
        : 'Wealth Management';
    const investWealthText = isPersonalAdviceEnabled
        ? 'Investments and Personal Advice'
        : 'Investments and Wealth Management';
    if (showWealth && !showInvest)
        return wealthText;
    if (showInvest && !showWealth)
        return 'Investments';
    if (showInvest && showWealth)
        return investWealthText;
    return 'Investments';
}
/**
 * Function to return correct allytmln based on Invest and Wealth relationships.
 *
 * @param isWealthManagement - wealth FF
 * @param isInvestUser
 * @param isWealthClient
 * @param title - content of link
 *
 * @returns {string}
 */
export function getInvestWealthAllytmln(isWealthManagement, isInvestUser, isWealthClient, isPersonalAdviceEnabled, title) {
    const investWealthAllytmln = isPersonalAdviceEnabled
        ? `profile-panel-${title} Investing Personal Advice`
        : `profile-panel-${title} Investing Wealth Management`;
    if (isWealthManagement && isInvestUser && isWealthClient)
        return investWealthAllytmln;
    return `profile-panel-${title} Investments`;
}
export const getBankSecureMessageTitle = (showBank, showDebtPlan) => {
    if (showDebtPlan && !showBank)
        return 'Plans';
    if (showDebtPlan && showBank)
        return 'Bank Accounts and Plans';
    return 'Bank Accounts';
};
export const getInvestSecureMessageTitle = (isInvest, showWealthManagement, isPersonalAdviceEnabled) => {
    const wealthText = isPersonalAdviceEnabled
        ? 'Personal Advice (Email)'
        : 'Wealth Management (Email)';
    const investWealthText = isPersonalAdviceEnabled
        ? 'Investments and Personal Advice (Email)'
        : 'Investments and Wealth Management (Email)';
    if (showWealthManagement && !isInvest)
        return wealthText;
    if (showWealthManagement && isInvest)
        return investWealthText;
    return 'Investments (Email)';
};
export const getInvestDocumentsTitle = (showInvest, showWealthManagement, isPersonalAdviceEnabled) => {
    const wealthText = isPersonalAdviceEnabled
        ? 'Personal Advice Documents'
        : 'Wealth Management Documents';
    const investWealthText = isPersonalAdviceEnabled
        ? 'Investments and Personal Advice Documents'
        : 'Investments and Wealth Management Documents';
    if (showWealthManagement && !showInvest)
        return wealthText;
    if (showWealthManagement && showInvest)
        return investWealthText;
    return 'Investment Documents';
};
//# sourceMappingURL=utils.js.map